<template>
  <div class="content">
    <n-card :more="true" title="Activity Content">
      <Row>
        <Col span="12" style="border-right: 1px solid #E5E5E5;border-bottom: 1px solid #E5E5E5" @click="active = 'date'">
          <block type="md-calendar" icolor="#2b7cba" text="CURRENT DATE" :value="today"></block>
        </Col>
        <Col span="12" style="border-bottom: 1px solid #E5E5E5;">
          <block type="md-time" icolor="#2b7cba" text="CURRENT TIME" :value="c_time" @click="active = 'clock'"></block>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="border-right: 1px solid #E5E5E5;">
          <block type="md-stats" icolor="#2b7cba" text="LOGINS LAST WEEK" value="4" @click="active = 'ranks'"></block>
        </Col>
        <Col span="12">
          <block type="md-stats" icolor="#2b7cba" text="LOGINS LAST MONTH" value="18" @click="active = 'ranks'"></block>
        </Col>
      </Row>
      <Row>
        <div class="chart-box" v-if="active == 'ranks'" >
          <ve-histogram :data="chartData" :settings="chartSetting"/>
        </div>
      </Row>
    </n-card>
  </div>
</template>
<script>
import nCard from '@/components/profile/nCard.vue'
import block from './activity-block'
import VeHistogram from 'v-charts/lib/histogram.common'
export default {
  components: {
    nCard,
    block,
    VeHistogram
  },
  data() {
    return {
      avater: '',
      name: 'John Doe',
      phone: '456123456',
      level: 'Sannifor nia',
      main: 'jonge@ddcs.tv',
      points: 250,
      chartData: {
          columns: ['日期', '访问用户', '下单用户', '下单率'],
          rows: [
            { '日期': '1/1', '访问用户': 1393, '下单用户': 1093, '下单率': 0.32 },
            { '日期': '1/2', '访问用户': 3530, '下单用户': 3230, '下单率': 0.26 },
            { '日期': '1/3', '访问用户': 2923, '下单用户': 2623, '下单率': 0.76 },
            { '日期': '1/4', '访问用户': 1723, '下单用户': 1423, '下单率': 0.49 },
            { '日期': '1/5', '访问用户': 3792, '下单用户': 3492, '下单率': 0.323 },
            { '日期': '1/6', '访问用户': 4593, '下单用户': 4293, '下单率': 0.78 }
          ]
        },
      active: 'rank',
      chartSetting: {
        axisSite: { right: ['下单率'] },
        yAxisType: ['KMB', 'percent'],
        yAxisName: ['数值', '比率'],
        opacity: .8
      },
      now: new Date(),
      c_time: "8 : 59 : 30 pm"
    }
  },
  mounted () {
    var now = new Date(), _this = this;
    setTimeout(this.getNow, 1000);
  },
  methods: {
    getNow () {
      var now = this.now = new Date();
      var h = now.getHours(),
          m = ("00" + now.getMinutes()).slice(-2),
          s = ("00" + now.getSeconds()).slice(-2);
      this.c_time = `${h > 12 ? h - 12 : h} : ${m} : ${s} ${h > 12 ? 'p' : 'a'}m`
      true && setTimeout(this.getNow,1000)
    }
  },
  computed: {
    today () {
      var date = ("00" + this.now.getDate()).slice(-2),
          month = ("00" + (this.now.getMonth()+1)).slice(-2),
          year = this.now.getFullYear()
      return `${month} / ${date} / ${year}`
    }
  }
}
</script>
<style>
.content {
  width: 400px;
  /* min-height: 300px; */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.chart-box {
  min-height: 500px;
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/activity-card.vue